module.exports = __webpack_public_path__ + "img/marker-green.42554554.png";